export default __webpack_public_path__ + "static/media/IMG_2443.51b1faa7.jpg";